import makeLookupModal from "../../UI/LookupModal/LookupModal";
import HighSchoolLookup from "./HighSchoolLookup";
const HighSchoolLookupModal = makeLookupModal(HighSchoolLookup, {
    pluralEntityName: "High Schools",
});
export default HighSchoolLookupModal;
